<template>
  <el-dialog
    v-dialogDrag
    class="small-dialog"
    :append-to-body="true"
    :visible.sync="visible"
    title="开始整改"
  >
    <el-form ref="form" label-width="150px" :model="formData" v-loading="loading">
      <el-form-item
        label="整改要求"
        prop="hiddenDangerOpinionsRectification"
        :rules="[
          {
            required: true,
            message: '请输入整改要求',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-input
          v-model="formData.hiddenDangerOpinionsRectification"
          disabled
          placeholder="请输入整改要求"
          maxlength="500"
          type="textarea"
          :rows="3"
          show-word-limit
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="方案负责人" prop="solutionLeaderUserId">
        <MultiplePersonSelect
          class="w-full"
          placeholder="请输入方案负责人"
          v-model="formData.solutionLeaderUserId"
        ></MultiplePersonSelect>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer flex justify-center items-center">
      <el-button
        :loading="loading"
        size="small"
        type="primary"
        class="iconfont icon-save"
        @click="save()"
        >开始整改</el-button
      >
      <el-button size="small" class="iconfont icon-close" @click="visible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { HiddenDangerRectificationChecklistApi } from '@wiz-api/double-prevention-management'
import { type } from 'os'
import MultiplePersonSelect from '@/components/safety/PersonSelect/MultiplePersonSelect'

const hiddenDangerRectificationChecklistApi = new HiddenDangerRectificationChecklistApi()
export default {
  name: 'hidden-reject-dialog',
  props: {
    id: {
      default: '',
    },
    propsFormData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  components: {
    MultiplePersonSelect,
  },
  watch: {
    visible(val) {
      if (!val) {
        this.$emit('cancel')
      }
    },
    propsFormData: {
      handler(val) {
        this.formData = JSON.parse(JSON.stringify(val)) || {}

        this.formData.hiddenDangerOpinionsRectification = val.hiddenDangerVerifierOpinions
        const userInfo = Wiz.AuthHooks.GetUserInfo()
        const { sub } = userInfo?.profile
        this.formData.solutionLeaderUserId = sub
      },
      immediate: true,
    },
  },
  data() {
    return {
      visible: true,
      formData: {},
      formLoading: false,
      loading: false,
    }
  },
  computed: {},
  methods: {
    save() {
      if (!this.id) {
        this.$message({
          showClose: true,
          message: '此条数据缺少id',
          type: 'warning',
        })
        return
      }
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.formLoading = true
          const [err, res] =
            await hiddenDangerRectificationChecklistApi.hiddenDangersVerificationStart({
              id: this.id,
              body: this.formData,
            })
          if (!err) {
            this.$emit('handleOk', res)
            this.$message({
              showClose: true,
              message: '开始整改成功',
              type: 'success',
            })
          }
          this.formLoading = false
        }
      })
    },
  },
  created() {
    // const userInfo = Wiz.AuthHooks.GetUserInfo()
    // const { sub } = userInfo?.profile
    // this.formData.solutionLeaderUserId = sub
  },
}
</script>

<style scoped lang="scss"></style>
